import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SITE_CONFIG } from '../config';
import { neighborhoods } from '../content/neighborhoods';
import { seoArticles } from '../content/seoArticles';
import './SiteFooter.css';

const hiddenPrefixes = ['/admin', '/chat', '/search', '/listing/', '/properties/list', '/add-contact', '/password-reset'];

export default function SiteFooter() {
  const { pathname } = useLocation();
  if (hiddenPrefixes.some((prefix) => pathname === prefix || pathname.startsWith(prefix))) return null;
  const guides = seoArticles.filter((article) => ['Buying', 'Selling', 'Relocation'].includes(article.category)).slice(0, 8);
  const socials = [
    ['Facebook', SITE_CONFIG.AGENT.FACEBOOK], ['Instagram', SITE_CONFIG.AGENT.INSTAGRAM],
    ['LinkedIn', SITE_CONFIG.AGENT.LINKEDIN], ['YouTube', SITE_CONFIG.AGENT.YOUTUBE],
    ['TikTok', SITE_CONFIG.AGENT.TIKTOK], ['X', SITE_CONFIG.AGENT.TWITTER]
  ].filter(([, href]) => href);

  return (
    <footer className="site-footer">
      <div className="site-footer-top">
        <div className="site-footer-brand">
          <img src={SITE_CONFIG.BRAND.LOGO_URL} alt={`${SITE_CONFIG.AGENT.NAME} logo`} />
          <p>Experienced guidance, personal service, and Southern California market knowledge since 1990.</p>
          <a href={`tel:${SITE_CONFIG.AGENT.PHONE}`}>(909) 519-1114</a>
          <a href={`mailto:${SITE_CONFIG.AGENT.EMAIL}`}>{SITE_CONFIG.AGENT.EMAIL}</a>
        </div>
        <nav><h2>Areas We Serve</h2>{neighborhoods.slice(0, 4).map((area) => <Link key={area.slug} to={`/area/${area.slug}`}>{area.name}</Link>)}</nav>
        <nav><h2>More Areas</h2>{neighborhoods.slice(4).map((area) => <Link key={area.slug} to={`/area/${area.slug}`}>{area.name}</Link>)}</nav>
        <nav><h2>Buying & Selling</h2>{guides.map((guide) => <Link key={guide.slug} to={`/guide/${guide.slug}`}>{guide.h1}</Link>)}</nav>
        <nav><h2>Explore</h2><Link to="/search">Property Search</Link><Link to="/about-us">Meet Jeff</Link><Link to="/blogs">Market Journal</Link><Link to="/reviews">Client Reviews</Link><Link to="/contact-us">Contact</Link></nav>
      </div>
      <div className="site-footer-connect">
        {SITE_CONFIG.AGENT.ZILLOW_REVIEW && <a href={SITE_CONFIG.AGENT.ZILLOW_REVIEW} target="_blank" rel="noreferrer">Leave a Zillow Review</a>}
        {socials.map(([label, href]) => <a key={label} href={href} target="_blank" rel="noreferrer">{label}</a>)}
      </div>
      <div className="site-footer-legal">
        <span>© {new Date().getFullYear()} Jeff Upp · {SITE_CONFIG.AGENT.BROKERAGE} · DRE #{SITE_CONFIG.AGENT.LICENSE}</span>
        <span><Link to="/privacy-policy">Privacy</Link><Link to="/terms-of-service">Terms</Link><Link to="/api-docs">API</Link></span>
      </div>
    </footer>
  );
}
